module.exports = __webpack_public_path__ + "img/img0.b69038e0.jpg";